import {url} from '@rocket-ui/tools';
import axios from 'axios';
import {getExecutorWebBaseUrl} from './executorWebBaseUrl';

export const axiosInstance = axios.create({
	baseURL: getExecutorWebBaseUrl(),
	paramsSerializer: (params) => url.stringifyQueryString(params),
});
